var _clipPath, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiArrowRightOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 12,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-ui--arrow-right-outline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h11.304v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-ui--arrow-right-outline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M8.488 9.084L4.465 5.06 5.525 4l5.834 5.834-5.833 5.833-1.06-1.06 4.022-4.023H-.64v-1.5z",
    fillRule: "evenodd"
  }))));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--arrow-right-outline-5cab8226e3bb9bf68b26835dee95143a.svg";
export { SvgIconUiArrowRightOutline as Component };